import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
    width: 100%;
    padding: 0.5rem;
    border-radius: 5px;
    background-color: var(--primary-color);
    cursor: pointer;
    :hover{
        filter: brightness(var(--brightness));
    }
`

const Title = styled.div`
    font-weight: ${props => props.fontWeight};
    font-size: 1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1; /* number of lines to show */
    -webkit-box-orient: vertical;
`

const Subtitle = styled.div`
    font-size: 0.8rem;
    color: var(--secondary-accent-color);
`

const OptionBlock = props => {
    const {
        title,
        subtitle,
        onSelect,
        closeHandler
    } = props

    const onSelectHandler = () => {
        onSelect && onSelect();
        closeHandler && closeHandler();
    }
    
    return (
        <Container onClick={onSelectHandler}>
            <Title fontWeight={!subtitle ? 'normal' : 'bold'}>{title}</Title>
            <Subtitle>{subtitle}</Subtitle>
        </Container>
    )
}

export default OptionBlock;